import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraSurface } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { cn } from '../lib/utils';
/**
 * The records offered after typing @ in the composer. Arrow keys move,
 * Enter or Tab picks, Esc closes (the composer handles the keys).
 */ export function MentionMenu({ hits, active, loading, query, onPick }) {
    return(// biome-ignore lint/a11y/useSemanticElements: a popover listbox for a rich-text composer; a native select cannot anchor to the caret
    /*#__PURE__*/ _jsx(SpecraSurface, {
        "aria-label": "Mention a record",
        className: "absolute bottom-full left-0 z-30 mb-1 max-h-72 w-full max-w-md overflow-y-auto border p-1 shadow-md",
        "data-testid": Testids.assistant.mentionMenu,
        radius: "md",
        role: "listbox",
        tone: "card",
        children: hits.length === 0 ? /*#__PURE__*/ _jsx("div", {
            className: "px-2 py-1.5 text-[length:var(--fs-ui-caption)] text-muted-foreground",
            children: loading ? 'Looking…' : query.length < 2 ? 'Type a program, deliverable, document, person or company' : `Nothing you can see matches “${query}”`
        }) : hits.map((h, i)=>// biome-ignore lint/a11y/useSemanticElements: options of the composer popover listbox above
            /*#__PURE__*/ _jsxs(SpecraButton, {
                "aria-selected": i === active,
                className: cn('h-auto w-full flex-col items-start gap-0 px-2 py-1.5 text-left font-normal text-[length:var(--fs-ui-body)]', i === active ? 'bg-muted text-foreground' : 'text-foreground hover:bg-muted'),
                "data-testid": Testids.assistant.mentionOption,
                // Keep the editor focused: pick on mousedown, before blur.
                onMouseDown: (e)=>{
                    e.preventDefault();
                    onPick(h);
                },
                role: "option",
                variant: "ghost",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "w-full truncate",
                        children: h.label
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "w-full truncate text-[length:var(--fs-ui-caption)] text-muted-foreground",
                        children: h.context
                    })
                ]
            }, `${h.kind}:${h.id}`))
    }));
}
